<template lang="pug">
svg.v-svg-icon.svg-icon
	use(:href="computedIcon")
</template>

<script>
import controller from '../../scripts/controller/controller';

export default {
	props: {
		icon: {
			type: String,
			default: ''
		},

		sprite: {
			type: String,
			default: '/local/assets/dist/icons/sprite.svg'
		}
	},

	computed: {
		computedIcon() {
			return `${this.sprite}?${controller.svgIconId}#svg-icon-${this.icon}`;
		}
	}
};
</script>